// utils/helpers.js

// Status and UI helpers
export const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'excellent':
      return { color: 'success', bgcolor: 'success.light' };
    case 'good':
      return { color: 'primary', bgcolor: 'primary.light' };
    case 'warning':
      return { color: 'warning', bgcolor: 'warning.light' };
    case 'critical':
      return { color: 'error', bgcolor: 'error.light' };
    default:
      return { color: 'default', bgcolor: 'grey.300' };
  }
};

export const getScoreColor = (score) => {
  if (score >= 80) return 'success';
  if (score >= 60) return 'primary';
  if (score >= 40) return 'warning';
  return 'error';
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

// Measurement helpers
export const formatMeasurementName = (measurementKey) => {
  const formatMap = {
    'temp': 'Temperature',
    'hum': 'Relative humidity',
    'co2': 'CO₂',
    'co': 'CO',
    'o3': 'O₃',
    'no2': 'NO₂',
    'nox': 'NOₓ',
    'voc': 'TVOC',
    'pm1_0': 'PM1.0',
    'pm2_5': 'PM2.5',
    'pm4_0': 'PM4.0',
    'pm10': 'PM10',
    'mass_c': 'Mass C',
    'fmhd': 'FMHD',
    'nh3': 'NH₃'
  };

  return formatMap[measurementKey] || measurementKey.toUpperCase();
};

export const getUnit = (measurementKey) => {
  const unitMap = {
    'temp': '°C',
    'hum': '%',
    'co2': 'ppm',
    'co': 'ppm',
    'o3': 'ppm',
    'no2': 'ppm',
    'nox': 'ppm',
    'voc': 'ppb',
    'pm1_0': 'µg/m³',
    'pm2_5': 'µg/m³',
    'pm4_0': 'µg/m³',
    'pm10': 'µg/m³',
    'mass_c': 'µg/m³',
    'fmhd': '%',
    'nh3': 'ppm'
  };

  return unitMap[measurementKey] || '';
};

export const getValueColor = (key, value) => {
  if (key === 'temp') {
    return value > 25 ? '#f44336' : '#2196f3';
  }
  if (key === 'hum') {
    return '#4caf50';
  }
  if (key === 'co2') {
    return value > 600 ? '#f44336' : '#4caf50';
  }
  if (key === 'voc') {
    return '#ff9800';
  }
  return '#666';
};

// Chart colors - using the more comprehensive color palette
export const getLineColors = () => {
  return [
    '#1f77b4', // blue
    '#ff7f0e', // orange
    '#2ca02c', // green
    '#d62728', // red
    '#9467bd', // purple
    '#8c564b', // brown
    '#e377c2', // pink
    '#7f7f7f', // gray
    '#bcbd22', // olive
    '#17becf', // cyan
    '#aec7e8', // light blue
    '#ffbb78', // light orange
    '#98df8a', // light green
    '#ff9896', // light red
    '#c5b0d5'  // light purple
  ];
};